import {
  type BadgeOrderImageSource,
  createBadgeOrderRequestSchema,
  type CreateBadgeOrderResponse,
  createBadgeOrderResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { post } from "@src/appV2/api";
import { API_TYPES } from "@src/appV2/api/constants";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

interface CreateBadgeOrderParams {
  workerId: string;
  qualification: string;
  imageSource: BadgeOrderImageSource;
}

export function useCreateBadgeSmithOrder(
  options: UseMutationOptions<CreateBadgeOrderResponse, unknown, CreateBadgeOrderParams> = {}
) {
  return useMutation<CreateBadgeOrderResponse, unknown, CreateBadgeOrderParams>({
    mutationFn: async ({ workerId, qualification, imageSource }) => {
      const response = await post({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/workers/${workerId}/badge-orders`,
        data: {
          data: {
            type: API_TYPES.badgeOrder,
            attributes: {
              qualification,
              imageSource,
              vendor: "badge-smith",
            },
          },
        },
        requestSchema: createBadgeOrderRequestSchema,
        responseSchema: createBadgeOrderResponseSchema,
      });

      return response.data as CreateBadgeOrderResponse;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.BADGE_SMITH_ORDER_CREATE_FAILURE,
    },
    ...options,
  });
}
